!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"));else if ("function" === typeof define && define.amd) define(["react"], t);else {
    var n = "object" === typeof exports ? t(require("react")) : t(e.react);

    for (var r in n) {
      ("object" === typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function (e) {
  return function (e) {
    var t = {};

    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        __webpack_require__.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 2);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t) {
    e.exports = "data:image/png;base64,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";
  }, function (e, t, n) {
    e.exports = n(8);
  }, function (e, t, n) {
    var r = n(4);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(6)(r, o);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(5)(!1)).push([e.i, ".integrated-help-launcher--container {\n  border: none;\n  display: flex;\n  height: 76px;\n  width: 76px;\n  position: fixed;\n  top: auto;\n  left: auto;\n  bottom: 24px;\n  right: 24px;\n  visibility: visible;\n  z-index: 2147483647;\n  max-height: 100vh;\n  max-width: 100vw;\n  -webkit-transition: none 0s ease 0s;\n  transition: none 0s ease 0s;\n  background: none transparent;\n  opacity: 1;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button {\n  z-index: 1;\n  cursor: pointer;\n  width: 52px;\n  height: 52px;\n  background-color: rgba(21, 122, 251, 1);\n  border-radius: .3125rem;\n  box-shadow: 0 2px 6px 0 rgba(32,0,0,.4);\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button img {\n  width: 52px;\n  height: 52px;\n}", ""]);
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" === typeof btoa) {
              var o = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(r),
                  i = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });

              return [n].concat(i).concat([o]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" === typeof i && (r[i] = !0);
        }

        for (o = 0; o < e.length; o++) {
          var a = e[o];
          "number" === typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    var r = {},
        o = function (e) {
      var t;
      return function () {
        return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        i = function (e) {
      var t = {};
      return function (e, n) {
        if ("function" === typeof e) return e();

        if ("undefined" === typeof t[e]) {
          var r = function (e, t) {
            return t ? t.querySelector(e) : document.querySelector(e);
          }.call(this, e, n);

          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (o) {
            r = null;
          }
          t[e] = r;
        }

        return t[e];
      };
    }(),
        a = null,
        s = 0,
        u = [],
        c = n(7);

    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var o = e[n],
            i = r[o.id];

        if (i) {
          i.refs++;

          for (var a = 0; a < i.parts.length; a++) {
            i.parts[a](o.parts[a]);
          }

          for (; a < o.parts.length; a++) {
            i.parts.push(addStyle(o.parts[a], t));
          }
        } else {
          var s = [];

          for (a = 0; a < o.parts.length; a++) {
            s.push(addStyle(o.parts[a], t));
          }

          r[o.id] = {
            id: o.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function listToStyles(e, t) {
      for (var n = [], r = {}, o = 0; o < e.length; o++) {
        var i = e[o],
            a = t.base ? i[0] + t.base : i[0],
            s = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function insertStyleElement(e, t) {
      var n = i(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = u[u.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), u.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = i(e.insertAt.before, n);
        n.insertBefore(t, o);
      }
    }

    function removeStyleElement(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = u.indexOf(e);
      t >= 0 && u.splice(t, 1);
    }

    function createStyleElement(e) {
      var t = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var r = function getNonce() {
          0;
          return n.nc;
        }();

        r && (e.attrs.nonce = r);
      }

      return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
    }

    function addAttrs(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function addStyle(e, t) {
      var n, r, o, i;

      if (t.transform && e.css) {
        if (!(i = t.transform(e.css))) return function () {};
        e.css = i;
      }

      if (t.singleton) {
        var u = s++;
        n = a || (a = createStyleElement(t)), r = applyToSingletonTag.bind(null, n, u, !1), o = applyToSingletonTag.bind(null, n, u, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = function createLinkElement(e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
      }(t), r = function updateLink(e, t, n) {
        var r = n.css,
            o = n.sourceMap,
            i = void 0 === t.convertToAbsoluteUrls && o;
        (t.convertToAbsoluteUrls || i) && (r = c(r));
        o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var a = new Blob([r], {
          type: "text/css"
        }),
            s = e.href;
        e.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
      }.bind(null, n, t), o = function o() {
        removeStyleElement(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = createStyleElement(t), r = function applyToTag(e, t) {
        var n = t.css,
            r = t.media;
        r && e.setAttribute("media", r);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), o = function o() {
        removeStyleElement(n);
      });

      return r(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else o();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = o()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var o = [], i = 0; i < n.length; i++) {
          var a = n[i];
          (s = r[a.id]).refs--, o.push(s);
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (i = 0; i < o.length; i++) {
          var s;

          if (0 === (s = o[i]).refs) {
            for (var u = 0; u < s.parts.length; u++) {
              s.parts[u]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var l = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, n, r) {
      var o = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = l(t, o);else {
        var i = document.createTextNode(o),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" !== typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var o,
            i = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = {};
    n.r(r), n.d(r, "startInteraction", function () {
      return s;
    });
    var o = {};

    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _typeof2(e) {
      return (_typeof2 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof2(e) {
        return typeof e;
      } : function _typeof2(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator) ? function _typeof(e) {
        return _typeof2(e);
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
      })(e);
    }

    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" !== typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    n.r(o), n.d(o, "saveHelpInteractionStart", function () {
      return u;
    }), n.d(o, "getLastHelpInteractionEpoch", function () {
      return c;
    }), n.d(o, "shouldLaunchHelpInteraction", function () {
      return l;
    });

    var i = n(0),
        a = n.n(i),
        s = function startInteraction(e) {
      return window.drift && window.drift.api.startInteraction({
        interactionId: e
      });
    },
        u = function saveHelpInteractionStart() {
      window.localStorage && window.localStorage.setItem && window.localStorage.setItem("drift-integrated-help-triggered", new Date().getTime() + "");
    },
        c = function getLastHelpInteractionEpoch() {
      var e = window.localStorage && window.localStorage.getItem && window.localStorage.getItem("drift-integrated-help-triggered"),
          t = parseInt(e);
      return isNaN(t) ? null : t;
    },
        l = function shouldLaunchHelpInteraction() {
      var e = c(),
          t = new Date();
      return t.setDate(t.getDate() - 1), !e || e < t.getTime();
    },
        f = n(1),
        p = n.n(f),
        d = (n(3), function (e) {
      function Launcher(e) {
        var t;
        return function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Launcher), (t = _possibleConstructorReturn(this, _getPrototypeOf(Launcher).call(this, e))).state = {
          show: !1
        }, t.hideLauncher = function () {
          t.state.show || console.warn("Integrated Help launcher is already hidden"), t.setState({
            show: !1
          });
        }, t.showLauncher = function () {
          t.state.show && console.warn("Integrated Help launcher is already visible"), t.setState({
            show: !0
          });
        }, t.setupWidget = function () {
          window.drift && window.drift.on("ready", function () {
            t.setState({
              show: !0
            }), window.drift.hide(), window.drift.on("sidebarOpen", t.hideLauncher), window.drift.on("welcomeMesage:open", function () {
              return window.drift.hide();
            }), window.drift.on("awayMessage:open", window.drift.hide()), window.drift.on("sidebarClose", t.showLauncherAndHideWidget), window.drift.config({
              enableWelcomeMessage: !1,
              enableCampaigns: !1,
              disableNewConversations: !0
            });
          });
        }, t.showLauncherAndHideWidget = function (e) {
          e.data.widgetVisible && window.drift.hide(), t.setState({
            show: !0
          });
        }, t.launchHelp = function () {
          l() ? t.launchInteraction() : window.drift.api.openChat();
        }, t.launchInteraction = function () {
          var e = t.props.interactionId;
          u(), t.setState({
            show: !1
          }, s(e));
        }, window.HelpLauncher = {
          hide: function hide() {
            return t.hideLauncher();
          },
          show: function show() {
            return t.showLauncher();
          }
        }, t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _setPrototypeOf(e, t);
      }(Launcher, i["Component"]), function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
      }(Launcher, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.props.interactionId ? this.setupWidget() : console.warn("No interaction id found to trigger help launcher");
        }
      }, {
        key: "render",
        value: function render() {
          return this.state.show ? a.a.createElement("div", {
            className: "integrated-help-launcher--container"
          }, a.a.createElement("div", {
            className: "integrated-help-launcher--button",
            onClick: this.launchHelp
          }, a.a.createElement("img", {
            src: p.a,
            alt: "background"
          }))) : null;
        }
      }]), Launcher;
    }());

    n.d(t, "widgetUtils", function () {
      return h;
    }), n.d(t, "helpUtils", function () {
      return y;
    });
    var h = r,
        y = o;
    t.default = d;
  }]);
});